/**
 * Shim for @vue/composition-api
 *
 * Vue 2.7+ has built-in Composition API support, so @vue/composition-api
 * is no longer needed. This shim re-exports Vue's built-in APIs and provides
 * a no-op install function for backwards compatibility with packages that
 * still depend on @vue/composition-api.
 *
 * This is needed because @lastboy/vue2 reports version 6.4.6 instead of 2.7.16,
 * which breaks @vue/composition-api's version detection.
 */

// Re-export everything from Vue
export * from 'vue';

// Import Vue default export
import Vue from 'vue';

// No-op install function since Vue 2.7 has built-in Composition API
export function install() {
  // No-op - Vue 2.7+ doesn't need the plugin
}

// Default export for Vue.use() compatibility
export default {
  install,
  // Re-export Vue itself for edge cases
  version: Vue.version,
};
